// pull in config vars
import * as config from "../config"
import getJamFilledCookie from "../getJamFilledCookie"
import getUserIdFromJamFilledCookie from "../getUserIdFromJamFilledCookie"
import fetch from "isomorphic-fetch"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"

export default async function getUserByIdInJamFilledStorage(
	JAM_ID: string,
): Promise<boolean> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/user/${getUserIdFromJamFilledCookie()}`,
			{
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
					jamid: JAM_ID,
				},
			},
		)

		const json = await res.json()

		localStorage.setItem("jamUser", JSON.stringify(json.user))

		return true
	} catch (e) {
		console.log(e)

		return false
	}
}
